import PropTypes from 'prop-types'
import { useEffect } from 'react'
import Preview from 'features/creative/preview/Preview'
import LandingUrl from 'features/creative/add/common/LandingUrl'
import TextInput from 'components/form/TextInput'
import SelectBox from 'components/form/SelectBox'
import { useDispatch, useSelector } from 'react-redux'
import {
  reset,
  selectSubject,
  setDescription,
  setIndividual,
  setMobileUrl,
  setPcUrl,
  subjectTypes,
} from 'features/creative/add/asset/subjectSlice'
import ErrorText from 'components/form/ErrorText'
import useChannelLandingUrlPolicy from 'features/creative/add/common/useChannalLandingUrlPolicy'
import Button from 'components/form/Button'
import { inactiveAsset } from 'features/creative/add/build/buildCreativeSlice'

const Subject = ({ disabled, errors, imported }) => {
  const dispatch = useDispatch()
  const {
    selectedSubject,
    description,
    landingUrl: { individual, mobileUrl, pcUrl },
  } = useSelector(state => state.creative.assets.subject)

  useChannelLandingUrlPolicy(v => setIndividual(v), disabled, imported)
  useEffect(
    () => () => {
      dispatch(reset())
    },
    [dispatch]
  )

  const onSelectSubject = v => dispatch(selectSubject(v))
  const onChangeDescription = v => dispatch(setDescription(v))
  const onChangeIndividual = v => dispatch(setIndividual(v))
  const onChangeMobileUrl = v => dispatch(setMobileUrl(v))
  const onChangePcUrl = v => dispatch(setPcUrl(v))

  return (
    <div className="cont_material">
      <div className="group_material">
        <div className="box_material">
          <strong className="subtit_subject2">
            텍스트형 &gt; 말머리
            <Button
              size="small"
              disabled={disabled}
              onClick={() => {
                dispatch(inactiveAsset('subject'))
              }}>
              삭제
            </Button>
          </strong>
          <div className="inner_material">
            <div className="material_item">
              <div className="tit_itemwrap">
                <strong className="tit_item">말머리</strong>
              </div>
              <div className="desc_item">
                <SelectBox
                  value={selectedSubject}
                  onValueChange={onSelectSubject}
                  placeholder="말머리 선택"
                  disabled={disabled}
                  error={errors?.subject}>
                  {subjectTypes.map(type => (
                    <SelectBox.Item key={type.id} value={type}>
                      {type.name}
                    </SelectBox.Item>
                  ))}
                </SelectBox>
                <ErrorText error={errors?.subject} />
              </div>
            </div>
            <div className="material_item">
              <div className="tit_itemwrap">
                <strong className="tit_item">내용</strong>
              </div>
              <div className="desc_item">
                <TextInput
                  value={description}
                  onValueChange={onChangeDescription}
                  placeholder="내용을 입력하세요"
                  maxLength={17}
                  trim
                  disabled={disabled}
                  error={errors?.description}
                />
                <ErrorText error={errors?.description} />
              </div>
            </div>
            <LandingUrl
              individual={individual}
              mobileUrl={mobileUrl}
              pcUrl={pcUrl}
              onChangeIndividual={onChangeIndividual}
              onChangeMobileUrl={onChangeMobileUrl}
              onChangePcUrl={onChangePcUrl}
              disabled={disabled}
              errors={{
                mobileUrl: errors?.mobileUrl,
                pcUrl: errors?.pcUrl,
              }}
            />
          </div>
        </div>
        <Preview
          type="SUBJECT"
          data={{
            kind: selectedSubject?.id,
            text: description,
          }}
        />
      </div>
    </div>
  )
}

export default Subject

Subject.propTypes = {
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    subject: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    description: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    mobileUrl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    pcUrl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  }),
  imported: PropTypes.bool,
}
